import styled from 'styled-components';
import colors from '../../../assets/colors';

export const Item = styled.tr`
  td {
    width: 100px;
    max-width: 100px;
    padding: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    
    .img {
      width: 35px;
      height: 35px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      margin: 0 auto;
      border: 2px solid #CCC;
      border-radius: 6px;
    }

    span { font-size: 0.9rem; }
    .red { color: ${colors.red}; }
    .price { text-decoration: ${props => (!props.specialPrice ? 'none' : 'line-through')} }
    
    .special-price { 
      display: ${props => (!props.specialPrice ? 'none' : 'block')};
      color: ${colors.primary};
    }

    button {
      display: flex;
      background: none;
      border: none;
      padding: 10px;
      margin-left: 3px;
      font-family: 'Open Sans', sans-serif;
      font-size: 0.9rem;
      color: ${colors.primary};
      cursor: pointer;
      
      .fa { margin-top: 2px; margin-right: 8px; }
      :hover { opacity: .9; }
    }
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const Table = styled.table`
  width: 100%;
  padding: 0 20px;

  tr {
    :first-child { 
      th { 
        padding-top: 20px;
        border-top-left-radius: 8px; 
      }

      td { padding-top: 20px; }
    }

    :last-child { 
      th { padding-bottom: 20px; }
      td { padding-bottom: 20px; }
    }

    th {
      width: 50%;
      background: #F1F1F1;
      padding: 10px 15px;
      font-size: 0.9rem;
      font-weight: 600;
      letter-spacing: -0.5px;
      color: #999;
      text-transform: uppercase;
    }

    td {
      padding: 10px 15px;

      span { font-size: 0.9rem; }
      .red { color: ${colors.red}; }
      .price { text-decoration: ${props => (!props.specialPrice ? 'none' : 'line-through')} }
      
      .special-price { 
        display: ${props => (!props.specialPrice ? 'none' : 'block')};
        color: ${colors.primary};
      }
    }
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const Footer = styled.div`
  background: #F1F1F1;
  padding: 5px;
  margin-top: 2px;
  margin-bottom: 30px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  
  button {
    display: block;
    background: none;
    border: none;
    padding: 10px;
    margin: 0 auto;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.9rem;
    color: ${colors.primary};
    cursor: pointer;
    
    .fa { margin-top: 2px; margin-right: 8px; }
    :hover { opacity: .9; }
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
`;
